module.exports = __webpack_public_path__ + "static/img/6.b7b4e66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/6.png
// module id = 4po6
// module chunks = 0